/** The URL to post to */
const url = 'https://sunovionexhibitbooth.com/tracking/track_latuda.php';
const sessionStorageKey = 'latuda-store-id';

const session = getSession();

export enum TrackingAction {
  NAVIGATION      = 0,
  LINK_CLICK      = 1,
  MODAL           = 2,
  FORM_SUBMIT     = 3,
  RESOURCE        = 4
}

export function getSession() {
  const id = localStorage.getItem(sessionStorageKey) || uuid();
  localStorage.setItem(sessionStorageKey, id);
  return id;
}

export function trackAction(action: string, type: TrackingAction) {
  console.log('[TRACKING]', `[${type}]`, action);

  const xhr = new XMLHttpRequest();
  xhr.open('POST', url, true);
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.send(
    JSON.stringify({
      action,
      timestamp: Date.now(),
      type,
      sessionID: session,
      show: localStorage.getItem('show') || ''
    })
  );
}

function uuid() {
  let uuid = '';
  let i: number;
  let random: number;
  for (i = 0; i < 32; i++) {
    // tslint:disable-next-line: no-bitwise
    random = Math.random() * 16 | 0;
    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }
    // tslint:disable-next-line: no-bitwise
    uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
  }
  return uuid;
}
